import React from "react";
import FilesUpload from "nbugs-files-upload";
import { Button, Divider, List } from "antd";
import { ENV } from "@/services/utils";
import styles from "./SelfDetail.less";

const { Item } = List;

function SelfDetail({
  reportUser,
  reportTime,
  score,
  remark,
  appendix,
  update,
  from,
  templateType = 1,
  reRender,
  noNeedUpdate
}) {
  const handleClick = () => {
    update(true);
  };
  return (
    <div className={styles.selfDetail}>
      <div className="normDetailTitle">
        <Divider orientation="left">自查自评</Divider>
      </div>
      <div className="selfDetailNews">
        <Item>
          <span className="itemName">填报人</span>:
          <span style={{ marginLeft: 16 }}>
            {from === "evaluate"
              ? `${reportUser || "-"}`
              : `${reportUser} (${reportTime})`}
          </span>
        </Item>
        <Item>
          <span className="itemName">
            {templateType === 3 ? "指标值" : "自评分数"}
          </span>
          :
          <span style={{ marginLeft: 16 }}>{score ? `${score}分` : "0分"}</span>
        </Item>
        <Item>
          <span className="itemName">
            {templateType === 3 ? "说明" : "自评说明"}
          </span>
          :<span style={{ marginLeft: 16 }}>{remark || "-"}</span>
        </Item>
        <Item>
          <span className="itemName">
            {templateType === 3 ? "说明附件" : "自评附件"}
          </span>
          :
          <div className="fieldsUpload" style={{ marginLeft: 16 }}>
            {appendix ? (
              <FilesUpload
                edit={1}
                type="pc"
                APIEnv={ENV}
                groupId={appendix}
                previewUrl={`//${window.location.hostname}/v2/preview/file`}
                key={appendix}
              />
            ) : (
              <span style={{lineHeight:'27px'}}>-</span>
            )}
          </div>
        </Item>
        {from === "self" && !noNeedUpdate && (
          <Item>
            <Button type="primary" onClick={handleClick}>
              更新填报
            </Button>
          </Item>
        )}
      </div>
    </div>
  );
}

export default SelfDetail;
